module.exports = __webpack_public_path__ + "static/user-research-number-806323f77cebfbdd477437b8ca220dd4.png";